<template>
  <div
    ref="speechBubble"
    v-motion
    :initial="{
      opacity: 0,
    }"
    :enter="{
      opacity: 1,
    }"
    :class="`start-chat-box ${msg[msgType]?.background} ${msg[msgType]?.borderColor} w-[95%] min-w-[350px] min-h-[120px] bottom-[125px] sm:w-[28%] sm:min-w-[580px] -mr-[18px]  xl:mr-[100px] drop-shadow-lg z-30 border-b-4 border-r-4 rounded-t-2xl rounded-bl-2xl flex justify-between p-8 flex-col space-y-6`"
  >
    <div class="flex flex-row items-center space-x-2">
      <img
        src="@/assets/images/icons-alert/ilust-voice.svg"
        alt="icon-voice"
        class="w-[37px]"
      />
      <p class="font-[800]" v-html="msg[msgType]?.title"></p>
    </div>
    <p v-html="msg[msgType]?.body"></p>
    <Button
      v-if="msg[msgType]?.button.show"
      class="btn-primary h-10"
      @click="msg[msgType]?.button.action"
    >
      {{ msg[msgType]?.button.title }}
    </Button>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { SpeechBubbleMsg } from "../chatbot.utils";

export default defineComponent({
  name: "speechBubble",
  emits: ["onCloseSpeechBubble", "onOpenChat", "onHomeroRandomQuestion"],
  mounted() {
    this.createMessage();
    setTimeout(() => {
      document.addEventListener("click", this.onClickOutside);
    }, 100);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.onClickOutside);
  },
  data() {
    return {
      msg: {} as Object,
    };
  },
  props: {
    startMessage: [Boolean],
    msgType: {
      type: String,
      default: "default",
    },
    user: Object,
  },
  methods: {
    createMessage(): void {
      this.msg = {
        default: {
          title: this.$t("labels.generic", {
            pt: "Oi! Está tudo bem por aí?",
            en: "Hey! Is everything okay over there?",
          }),
          body: this.$t("labels.generic", {
            pt: SpeechBubbleMsg.default.pt,
            en: SpeechBubbleMsg.default.en,
          }),
          button: {
            title: "",
            show: false,
            action: () => {
              this.onCloseSpeechBubble();
            },
          },
          background: "bg-white",
          borderColor: "border-h-primary-500",
        },
        tutorial: {
          title: this.$t("labels.generic", {
            pt: `Olá, ${this.user?.firstName}`,
            en: `Hello, ${this.user?.firstName}`,
          }),
          body: this.$t("labels.generic", {
            pt: SpeechBubbleMsg.tutorial.pt,
            en: SpeechBubbleMsg.tutorial.en,
          }),
          button: {
            title: "Ok, entendi",
            show: true,
            action: () => {
              this.onCloseSpeechBubble();
            },
          },
          background: "bg-white",
          borderColor: "border-h-secondary-600",
        },
        tutorial2: {
          title: this.$t("labels.generic", {
            pt: `Você está indo muito bem, ${this.user?.firstName}`,
            en: `Hello, ${this.user?.firstName}`,
          }),
          body: this.$t("labels.generic", {
            pt: SpeechBubbleMsg.tutorial2.pt,
            en: SpeechBubbleMsg.tutorial2.en,
          }),
          button: {
            title: "Tudo certo",
            show: true,
            action: () => {
              this.onCloseSpeechBubble();
            },
          },
          background: "bg-white",
          borderColor: "border-h-secondary-600",
        },
        tutorial3: {
          title: this.$t("labels.generic", {
            pt: `Está tudo bem, ${this.user?.firstName}?`,
            en: `Hello, ${this.user?.firstName}`,
          }),
          body: this.$t("labels.generic", {
            pt: SpeechBubbleMsg.tutorial3.pt,
            en: SpeechBubbleMsg.tutorial3.en,
          }),
          button: {
            title: "Entendi",
            show: true,
            action: () => {
              this.onCloseSpeechBubble();
            },
          },
          background: "bg-white",
          borderColor: "border-h-secondary-600",
        },
        QUESTION_RANDOM: {
          title: this.$t("labels.generic", {
            pt: `Que tal revisarmos o conteúdo?`,
            en: `How about revising the content?`,
          }),
          body: this.$t("labels.generic", {
            pt: SpeechBubbleMsg.QUESTION_RANDOM.pt,
            en: SpeechBubbleMsg.QUESTION_RANDOM.en,
          }),
          button: {
            title: "Quero testar o que aprendi!",
            show: true,
            action: () => {
              this.onOpenChat("QUESTION_RANDOM");
            },
          },
          background: "bg-white",
          borderColor: "border-h-secondary-600",
        },
        QUESTION_WRONG: {
          title: this.$t("labels.generic", {
            pt: `Que tal revisarmos o conteúdo?`,
            en: `Hello, ${this.user?.firstName}`,
          }),
          body: this.$t("labels.generic", {
            pt: SpeechBubbleMsg.QUESTION_WRONG.pt,
            en: SpeechBubbleMsg.QUESTION_WRONG.en,
          }),
          button: {
            title: "Quero testar o que aprendi!",
            show: true,
            action: () => {
              this.onOpenChat("QUESTION_WRONG");
            },
          },
          background: "bg-white",
          borderColor: "border-h-secondary-600",
        },
      };
    },
    onCloseSpeechBubble(): void {
      this.$emit("onCloseSpeechBubble");
    },
    onOpenChat(questionType: string): void {
      this.$emit("onCloseSpeechBubble");
      this.$emit("onOpenChat");
      this.$emit("onHomeroRandomQuestion", questionType);
    },
    onClickOutside(event): void {
      const myDiv = this.$refs.speechBubble as HTMLElement;
      if (myDiv && !myDiv.contains(event.target as Node)) {
        this.onCloseSpeechBubble();
      }
    },
  },
});
</script>
